import { render, staticRenderFns } from "./LawStatisitcDetailsPieTable.vue?vue&type=template&id=810f47ac&scoped=true"
import script from "./LawStatisitcDetailsPieTable.vue?vue&type=script&lang=js"
export * from "./LawStatisitcDetailsPieTable.vue?vue&type=script&lang=js"
import style0 from "./LawStatisitcDetailsPieTable.vue?vue&type=style&index=0&id=810f47ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810f47ac",
  null
  
)

export default component.exports